'use strict';

angular.module('app.influencerGroup')
	.controller('influencerGroupCtrl', ['$scope', 'influencerGroupService', 'detailInfluencerGroupService', 'measureService', '$compile', '$timeout', '$modal','$state','$rootScope', '$stateParams', 'TRACK_EVENTS',
		function ($scope, influencerGroupService, detailInfluencerGroupService, measureService, $compile, $timeout, $modal, $state, $rootScope, $stateParams, TRACK_EVENTS){
		
        $scope.influencerGroups = [];
        $scope.influencers = [];
        $scope.manualAddedInfluencerList = null;
        $scope.selectedAdvertiser = 0;

        if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
            $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
        }

	    $scope.getInfluencerGroupList = function(selected_company_id) {
	    	influencerGroupService.getInfluencerGroupList(selected_company_id, true)
                .then(function(response) {
                    $scope.influencerGroups = [];
                    angular.forEach(response.data, function(item) {
                        item.total_reach = item.total_reach;
                        item.total_engagement = item.total_engagement;
                        $scope.influencerGroups.push(item);
                    });
                }, function(response) {
                    var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                })
	    }

        $scope.getInfluencerGroupList($scope.selectedAdvertiser);

        $scope.$on('reload_influencerGroup', function(event, args) {
            if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
                $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
            }
            
            $scope.getInfluencerGroupList($scope.selectedAdvertiser);
        });

        $scope.addNewInfluencerGroup = function(influencer_group_id, isAddNewInfluencerGroup) {
            var addNewInfluencerGroupModal = $modal.open({
                scope: $scope,
                templateUrl: 'app/influencerGroup/addNewInfluencerGroup/addNewInfluencerGroup.html?app_v=deployDate',
                controller: 'addNewInfluencerGroupCtrl'
            });

            $scope.influencerGroupId = influencer_group_id;
            $scope.isAddNewInfluencerGroup = isAddNewInfluencerGroup;
            $scope.addNewInfluencerGroupModal = addNewInfluencerGroupModal;
        }

        $scope.deleteInfluencerGroup = function(influencer_group) {
            var deleteInfluencerGroupConfirmModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/influencerGroup/influencerGroupPopup/influencerGroupConfirmDelete.html?app_v=deployDate',
                controller: 'DeleteInfluencerGroupCtrl'
            });

            $scope.influencer_group_id = influencer_group.influencer_group_id;
            $scope.influencer_group_name = influencer_group.influencer_group_name;
            $scope.deleteInfluencerGroupConfirmModalInstance = deleteInfluencerGroupConfirmModalInstance;
        }

        $scope.detailInfluencerGroup = function(influencer_group_id, group_name){
            // Mixpanel tracking influencer group clicking
            analytics.track(
                TRACK_EVENTS.CLICK_ON_INFLUENCER_GROUP.EVT_NAME,
                {
                    "item": TRACK_EVENTS.CLICK_ON_INFLUENCER_GROUP.ITEM_NAME,
                    "target_type": TRACK_EVENTS.CLICK_ON_INFLUENCER_GROUP.ITEM_NAME,
                    "target_name": group_name,
                    "target_id": influencer_group_id
                }
            );

            $state.transitionTo("home.detailInfluencerGroup", {
            influencer_group_id : influencer_group_id
            }, {
                reload: false,
                inherit: false,
                notify: true
                
            });
        }

        $scope.openModalAddInfluencerToInfluencerGroup = function(influencer_group_id, company_id) {
            var addInfluencerModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/influencerGroup/detailInfluencerGroup/addInfluencerToInfluencerGroup/addInfluencerToInfluencerGroup.html?app_v=deployDate',
                controller: 'addInfluencerToInfluencerGroupCtrl'
            });
            
            $scope.addInfluencerModalInstance = addInfluencerModalInstance;
            detailInfluencerGroupService.getManualAddedInfluencerList(influencer_group_id)
            .then(function(result){
                $scope.manualAddedInfluencerList = result.data;
            })
            .catch(function(message){
            })
            .finally(function(){
            }); 

            $scope.influencer_group_id = influencer_group_id;
            $scope.company_id = company_id;
            $scope.manualAddedInfluencerList;

            addInfluencerModalInstance.result.then(function (result) {
                if(result != null && result.reload) {
                    $rootScope.$broadcast('reload_influencerGroup', {});
                    $rootScope.$broadcast('reload_influencerGroupPage', {});
                }
            }, function () {
                
            });
        }
}])

.controller('DeleteInfluencerGroupCtrl', ['$scope', '$rootScope', '$modal', 'influencerGroupService', '$modalInstance',
    function ($scope,$rootScope, $modal, influencerGroupService, $modalInstance) {
        $scope.confirmDeleteInfluencerGroup = function () {
            var params = {
                id: $scope.influencer_group_id
            }

            influencerGroupService.deleteInfluencerGroup(params, true)
                .then(function (responseDeleteCampaign) {
                    $scope.closeModal();
                    $rootScope.$broadcast('reload_influencerGroup', {});
                    $rootScope.$broadcast('reload_influencerGroupPage', {});
                }, function (responseDeleteCampaign) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseDeleteCampaign.message;
                });
        }

        $scope.closeModal = function () {
            $modalInstance.close();
        }
    }
])